module.exports = __webpack_public_path__ + "static/media/personFutureSalesForce.dbe0347b.png";